import type { StatusType, Column, MobileConfig } from '@chikara/ui';
import { t } from '@/i18n';

export const STATUS_TYPE_MAP: Record<string, StatusType> = {
    active: 'activa',
    blocked: 'bloqueada',
    no_limit: 'sin-limite-asignado',
    requested: 'solicitada',
    received: 'recibida',
    pending_approval: 'pendiente',
    enabled: 'activa',
    disabled: 'bloqueada',

    ordered: 'ordered',
    confirm: 'confirm',
    customazing: 'customazing',
    sent: 'sent',
    on_transit: 'on_transit',
};

export function getStatusType(status: string): StatusType {
    return STATUS_TYPE_MAP[status] ?? 'pendiente';
};

export const ACTIVITY_MOVEMENT_COLUMNS: Column[] = [
    { key: 'cdate', label: t('dashboard.card.detail.activity.table.date'), width: '20%' },
    { key: 'movement', label: t('dashboard.card.detail.activity.table.movement'), width: '35%' },
    { key: 'amount', label: t('dashboard.card.detail.activity.table.amount'), width: '15%' },
    { key: 'type', label: t('dashboard.card.detail.activity.table.type'), width: '15%' },
    { key: 'status', label: t('dashboard.card.detail.activity.table.status'), width: '15%' },
];

export const ACTIVITY_MOVEMENT_MOBILE_CONFIG: MobileConfig = {
    primaryField: 'cdate',
    secondaryField: 'movement',
    expandableFields: ['amount', 'type', 'status'],
};